// import components
import { styled, Box } from '@mui/material';

// import types
import { StyledEventGridBoxColumns } from './ListView.types';

// import utils
import { getGridTemplateColumns } from './ListView.utils';

export const StyledListViewBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: `calc(100% - ${theme.spacing(20)}px)`
}));

export const StyledAutocompleteBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '60px'
});

export const StyledListItemsBox = styled(Box)(({ theme }) => ({
  flex: '1 1 100%',
  overflowX: 'hidden',
  overflowY: 'auto',
  height: theme.spacing(13)
}));

export const StyledEventsBox = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 49,
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const StyledEventGridBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'columns'
})<{ columns: StyledEventGridBoxColumns }>(({ columns }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: getGridTemplateColumns(columns)
}));

export const StyledFixedBox40 = styled(Box)(({ theme }) => ({
  width: theme.spacing(10)
}));

export const StyledTotalTimeBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  fontSize: theme.typography.body1.fontSize,
  fontFamily: 'SourceSansPro-SemiBold'
}));
